import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  ICheckboxSelectionData,
  ISelectableCardDetails,
  SharedConstants
} from '@app/eds';

@Component({
  selector: 'app-selectable-detail-card',
  templateUrl: './selectable-detail-card.component.html',
  styleUrls: ['./selectable-detail-card.component.scss']
})
export class SelectableDetailCardComponent {
  // List of details of the card
  @Input() cardDetails: ISelectableCardDetails[] = [];

  // Whether the cards are clickable or not
  @Input() isClickable = false;

  // Event emitter when the checkbox has been selected
  @Output() checkboxSelection: EventEmitter<ICheckboxSelectionData> =
    new EventEmitter<ICheckboxSelectionData>();

  // Emits event when a card is clicked with the id data
  @Output() cardClick: EventEmitter<string> = new EventEmitter<string>();

  // Class name for title-subtitle component
  @Input() titleSubtitleClassName: string = SharedConstants.EMPTY_STRING;

  /**
   * When the checkbox has been clicked on.
   *
   * @param {ICheckboxSelectionData} cardCheckboxData
   */
  onCheckboxSelection = (cardCheckboxData: ICheckboxSelectionData) =>
    this.checkboxSelection.emit(cardCheckboxData);

  /**
   * When the card is being clciked on.
   *
   * @param {ISelectableCardDetails} cardDetail
   */
  onCardClickHandler = (cardDetail: ISelectableCardDetails) =>
    (cardDetail.isClickable ?? this.isClickable) && this.cardClick.emit(cardDetail.id);

  /**
   * This function is called to get the class of the card-content
   * based on if the card has a label or not.
   *
   * @param {ISelectableCardDetails} cardDetail: Details of the card.
   * @returns the class of the card-content.
   */
  getCardContentClass = (cardDetail: ISelectableCardDetails) =>
    cardDetail.cardLabelKey || cardDetail.errorTagTextKey
      ? 'content-with-label'
      : 'content-without-label';
}
